import { VehicleDataRequest } from "@product-pages/model/types";
import { carType } from "./types";
import { parseAmount } from "@components/common/amount";

export const mapVehicleData = (data: any): VehicleDataRequest => {
  return {
    vehicleData: {
      ...(data.vehicleData.vin && {
        vin: data.vehicleData.vin,
      }),
      isUsed: data.vehicleData.isUsed === carType.USED,
      model: {
        manufacturer: data.vehicleData.model.manufacturer,
        name: data.vehicleData.model.name,
        descriptionLong: data.vehicleData.model.descriptionLong,
        year: Number(data.vehicleData.model.year),
        code: data.vehicleData.model.code,
        ...(data.vehicleData.model.manufacturerCode && {
        manufacturerCode: data.vehicleData.model.manufacturerCode,
      }),
      ...(data.vehicleData.model.typeCode && {
        typeCode: data.vehicleData.model.typeCode,
      }),
      },
      recommendedRetailPriceAmount: {
        amount: parseAmount(data.vehicleData.recommendedRetailPriceAmount.amount),
      },
      retailPriceAmount: {
        amount: parseAmount(data.vehicleData.retailPriceAmount.amount),
      },
      deliveryData: {
        deliveryDate: data.vehicleData.deliveryData.deliveryDate,
      },
      ...(data.vehicleData.initialRegistrationDate && {
        initialRegistrationDate: data.vehicleData.initialRegistrationDate,
      }),
      ...(data.vehicleData.odometer && { odometer: Number(data.vehicleData.odometer) }),
      orderDate: data.vehicleData.orderDate,
    },
  };
};
